export default __webpack_public_path__ + "static/media/emptyBetSlip.7254c37c.svg";